var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Schema } from "../decorators/type.js";
import "ajv";
import "./clone.js";
import "bitecs";
import "./typehelpers.js";
import "../enums-86f58524.js";
import "../global-33d5eebf.js";
const eqSet = (xs, ys) => xs.size === ys.size && Array.from(xs).every((x) => ys.has(x));
class ByteArray extends Schema {
  constructor(values) {
    super(values);
    __publicField(this, "bytes", /* @__PURE__ */ new Set());
  }
  get(index) {
    return this.bytes.has(index);
  }
  set(index, active) {
    if (active) {
      this.bytes.add(index);
    } else {
      this.bytes.delete(index);
    }
  }
  has(index) {
    return this.get(index);
  }
  equals(other) {
    if (!other) {
      return false;
    }
    return eqSet(this.bytes, other.bytes);
  }
  compare(indexes) {
    return indexes.every((index) => this.get(index));
  }
  enable(index) {
    this.set(index, true);
  }
  disable(index) {
    this.set(index, false);
  }
  getEnabled() {
    return Array.from(this.bytes.values());
  }
}
export {
  ByteArray
};
//# sourceMappingURL=byteArray.js.map
